import { message } from 'antd';
export default () => next => async (action) => {
  if (!action.promise) {
    return next(action);
  }
  next({
    type: action.type.PENDING
  });
  try {
    const { data } = await action.promise;
    if (action.success) {
      message.success(action.success);
    }
    next({ ...action, type: action.type.RESOLVED, data })
  } catch (error) {
    next({ ...action, type: action.type.REJECTED, error });
    if (action.error) {
      message.error(action.error)
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/middlewares/promiseMiddleware.js